<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/finance/segmentDetails";
export default {
  name: "",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis,
        list: p => {
          p.dataType = "S_C";
          return apis.tax(p);
        }
      },
      config: {},
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [],
          methods: {}
        }
      },
      fields: [
        {
          name: () => this.$tz("订单号"),
          key: "airway_bill_number",
          minWidth: 130
        },
        {
          name: () => this.$tz("目的国"),
          key: "to_country",
          minWidth: 130
        },
        {
          name: () => this.$tz("出库时间"),
          key: "outbound_time",
          minWidth: 130
        },
        {
          name: () => this.$tz("客户,原单号"),
          key: "client_refer_code",
          minWidth: 130
        },
        {
          name: () => this.$tz("币种"),
          key: "to_country_currency",
          minWidth: 130
        },
        {
          name: () => this.$tz("结算状态"),
          key: "finance_status_txt",
          minWidth: 130
        },
        {
          name: () => this.$tz("提单号"),
          key: "mawb",
          minWidth: 130
        },
        {
          name: () => this.$tz("申报价值"),
          key: "values",
          minWidth: 130
        },
        {
          name: () => this.$tz("税费"),
          key: "vat_fee",
          minWidth: 130
        }
      ]
    };
  }
};
</script>

<style scoped></style>
